export default __webpack_public_path__ + "static/topo-menu-desk-d25233389e40e20153ffaf52c8b1c759.png";